export enum WidgetTypesEnum {
  BUTTON = 'button',
  FORM = 'form',
  QR = 'qr',
}

export interface ICalculateWidgetResult {
  amount: string;
  currency: string;
  currency_type: 'fiat' | 'crypto';
  is_subtract: boolean;
  cashback_amount?: string;
  network?: string;
  payer_amount?: string;
  payment_currency?: string;
}

export interface IWidgetItem {
  customization: {
    background_color: string;
    button_color: string;
    header_color: string[];
    qr_color: string;
    width: number;
  };
  network: string;
  type: WidgetTypesEnum;
  uuid: string;
  amount?: string;
  cashback_amount?: string;
  currency?: string;
  currency_type?: 'fiat' | 'crypto';
  is_subtract?: boolean;
  name?: string;
  payer_amount?: string;
  payment_currency?: string;
  payment_name?: string;
  script?: string;
}

export interface IWidgetCurrency {
  code: string;
  icon: string;
  decimal?: number;
  name?: string;
  type?: 'crypto' | 'fiat';
}
